import React, { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('nav-open');
    } else {
      document.body.classList.remove('nav-open');
    }
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className={isScrolled ? 'scrolled' : ''}>
      <nav>
        <div className="logo">
          <img src="/images/logo_no_back.webp" alt="VESNYANKY" width="1120" height="1120" />
          <span>VESNYANKY</span>
        </div>
        <button
          className={`nav-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger"></span>
        </button>
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <li><a href="#pro-nas" onClick={closeMenu}>Про нас</a></li>
          <li><a href="#benefits" onClick={closeMenu}>Що ти отримаєш</a></li>
          <li><a href="#products" onClick={closeMenu}>Продукти</a></li>
          <li><a href="#gallery" onClick={closeMenu}>Фотогалерея</a></li>
          <li><a href="#questions" onClick={closeMenu}>Питання</a></li>
          <li><a href="#atmosphere" onClick={closeMenu}>Наша атмосфера</a></li>
          <li><a href="#reviews" onClick={closeMenu}>Відгуки</a></li>
        </ul>
      </nav>
    </header>
  );
}